import { render, staticRenderFns } from "./StudentQuizes.vue?vue&type=template&id=424cbbf1&scoped=true"
import script from "./StudentQuizes.vue?vue&type=script&lang=js"
export * from "./StudentQuizes.vue?vue&type=script&lang=js"
import style0 from "./StudentQuizes.vue?vue&type=style&index=0&id=424cbbf1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424cbbf1",
  null
  
)

export default component.exports